import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { DeviceService } from 'src/app/shared/services/device/device.service';

@Component({
  selector: 'app-device-list',
  templateUrl: './device-list.component.html',
  styleUrls: ['./device-list.component.scss']
})
export class DeviceListComponent implements OnInit {
  devices: any[] = [];
  loading = false;
  error = '';

  constructor(private deviceService: DeviceService) {}

  ngOnInit(): void {
    this.fetch();
  }

  fetch(): void {
    this.loading = true;
    this.error = '';
    this.deviceService.getDevices()
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          this.devices = res || [];
          this.loading = false;
        },
        error: () => {
          this.error = 'Unable to load devices right now.';
          this.loading = false;
        }
      });
  }

  allow(device: any): void {
    if (!device._id) { return; }
    this.deviceService.allowDevice(device._id)
      .pipe(first())
      .subscribe(() => this.fetch());
  }

  deny(device: any): void {
    if (!device._id) { return; }
    this.deviceService.denyDevice(device._id)
      .pipe(first())
      .subscribe(() => this.fetch());
  }

  isAllowed(device: any): boolean {
    if (device && typeof device.allowed === 'boolean') {
      return device.allowed;
    }
    return true;
  }
}
